import React, { Fragment } from 'react';
import {
	Button,
	Dropdown,
	Form,
	Modal,
	TextArea,
	Icon,
	Dimmer,
	Loader,
	Accordion,
	Segment,
	Table,
	Checkbox
} from 'semantic-ui-react';
import { inject, observer } from 'mobx-react';
import Rx from 'stores/Rx';
import * as styles from './styles';
import { observable, IObservableArray, toJS } from 'mobx';
import type { AssignableUser } from 'stores/Account';
import MessageBox from 'components/MessageBox';
import MsgStore from 'stores/MsgStore';
import UiShared from 'stores/UiShared';
import DayPickerInput from 'components/DayPickerInput';
import File from 'stores/File';
import Auth from 'stores/Auth';
import ItemInfor from 'stores/ItemInfor';
import * as yup from 'yup';
import titles from 'data/titles';
import states from 'data/states';
import sexes from 'data/sexes';
import eyes from 'data/eyes';
import doses from 'data/doses';
import PrescriberPractice from 'stores/PrescriberPractice';
import Prescriber from 'stores/Prescriber';
import Patient from 'stores/Patient';
import _ from 'lodash';
import API from 'api';
import TextareaAutosize from 'react-textarea-autosize';
const ORDERED = ['AMD', 'DMO', 'BRVO', 'CRVO', 'UVEITIS', 'PM', 'Rare CNV (not AMD)'];
const doseCodes = ['D', 'N', 'X'];

@inject(rootStore => ({
	auth: rootStore.auth,
	uiShared: rootStore.uiShared
}))
@observer
export default class ScriptNew extends React.Component {
	props: {
		isOpen: boolean,
		scriptId: number,
		onRequestReload: () => {},
		onRequestClose: () => {},
		auth?: Auth,
		uiShared: UiShared
	};

	static defaultProps = {
		isOpen: false
	};
	uploadInput = React.createRef();

	msgStore: MsgStore = new MsgStore();

	@observable filesToUpload: IObservableArray<File> = [];
	@observable active = {};
	@observable responseData = '';
	@observable assessmentDetailsText = '';
	@observable perDayValue = '';
	@observable doseDdlValue = 'D';
	@observable loading: boolean = false;
	@observable itemInforEdit: boolean = false;
	@observable showButtons: boolean = false;
	@observable showDeleteConfirmDlg: boolean = false;
	@observable showCancelConfirmDlg: boolean = false;
	@observable showIHICheckDlg: boolean = false;
	@observable showResponseMsg: boolean = false;
	@observable hideRx: boolean = false;
	@observable debugIdx: number = -1;
	@observable showDebug: boolean = false;
	@observable manualUploadSwitch: boolean = false;
	@observable showPatientDetails: boolean = false;
	@observable rx: Rx = null;
	@observable itemInforValue: ItemInfor = null;
	@observable itemInforEditValues: Array<{ text: any, value: any }> = [];
	@observable prescriberId: number = 0;
	@observable practiceId: number = 0;
	@observable programIds: Array<number> = [];
	@observable therapeuticAreas: Array<object> = [];
	@observable practicePrograms: Array<object> = [];
	@observable treatmentTypes: Array<object> = [];
	@observable drugs: Array<object> = [];
	@observable therapeuticAreaValue: number = 0;
	@observable drugValue: string = '';
	@observable indications: Array<object> = [];
	@observable indicationValue: string = '';
	@observable prescribers: Array<object> = [];
	@observable practices: Array<object> = [];
	@observable storedFiles = [];
	pps: Array<PrescriberPractice> = [];
	iis: Array<object> = [];
	iisDesc: Array<object> = [];
	prescriberAll: IObservableArray<Prescriber> = [];
	practiceAll: IObservableArray<Practice> = [];
	itemInfors: Array<ItemInfor> = [];
	@observable isLoadingPatientSearch: boolean = false;
	@observable isLoadingIHICheck: boolean = false;
	@observable editNotesMode: boolean = false;
	@observable
	commands = [
		{
			name: 'updateAuthority',
			json: true
		},
		{
			name: 'cancelAuthority',
			params: 'prescriberID/authorityPrescriptionNumber/authorityUniqueId'
		},
		{
			name: 'enquireAuthority',
			params: 'prescriberID/authorityPrescriptionNumber/authorityUniqueId'
		}
	];

	setActive = val => {
		this.inputJsonValue = '';
		this.inputParamsValue = '';
		this.responseData = '';
		this.active = val;
	};

	loadRx = async () => {
		this.loading = true;
		this.rx = await Rx.loadById(this.props.scriptId);
		this.showButtons = true;
		if (doseCodes.includes(this.rx.dose)) {
			this.doseDdlValue = this.rx.dose;
			this.perDayValue = '';
		} else {
			this.doseDdlValue = '-';
			this.perDayValue = this.rx.dose;
		}
		if (this.prescriberAll.length === 0 || this.therapeuticAreas.length === 0) {
			await this.loadDropdownLists();
		}
		const pp = _.find(this.pps, { id: this.rx.prescriberPracticeID });
		this.prescriberId = pp.prescriberID;
		this.practiceId = pp.practiceID;
		this.itemInforValue = this.rx?.ItemInfo;
		this.drugValue = this.itemInforValue?.itemName;
		this.therapeuticAreaValue = this.itemInforValue?.therapeuticAreaID;
		this.indicationValue = this.itemInforValue?.indication;
		const isReadOnly =
			this.props.auth?.user?.role === 'viewer' ||
			['approved', 'cancelled'].includes(this.rx?.status);
		if (!isReadOnly) {
			this.getPrescribers();
			this.getPractices();
			this.getIndications();
			this.getDrugs();
			this.getTreatmentPhases();
		}
		this.initForm();
		this.loading = false;
	};

	loadDropdownLists = async () => {
		await this.loadItemInfos();
		await Promise.all([this.loadPrescriberPractices(), this.loadPracticePrograms()]);
	};

	sortObjects = (arr, sortBy) => {
		if (!(arr && arr.length && sortBy)) return [];
		return arr.sort(function(a, b) {
			if (a[sortBy] < b[sortBy]) {
				return -1;
			}
			if (a[sortBy] > b[sortBy]) {
				return 1;
			}
			return 0;
		});
	};

	loadPrescriberPractices = async () => {
		let pps = await PrescriberPractice.loadAllByUser(this.props.auth?.user?.id);
		pps = toJS(pps).filter(
			pps => !pps.disabled && !pps.Practice.disabled && !pps.Prescriber.disabled
		);
		this.prescriberAll = pps
			.map(pps => {
				return Object.assign({}, pps.Prescriber, {
					therapeuticAreaID: pps.Practice.therapeuticAreaID
				});
			})
			.filter(p => !p.disabled);
		const practices = pps.map(pps => pps.Practice).filter(p => !p.disabled);
		this.practiceAll = this.removeDuplicates(practices, 'id');
		this.pps = pps.map(pps => {
			return {
				id: pps.id,
				prescriberID: pps.prescriberID,
				practiceID: pps.practiceID,
				therapeuticAreaID: pps.Practice.therapeuticAreaID,
				therapeuticArea: pps.Practice.TherapeuticArea.name
			};
		});
		let therapeuticAreas = this.removeDuplicates(this.pps, 'therapeuticAreaID');
		this.therapeuticAreas = therapeuticAreas
			.filter(el => this.itemInfoExistForArea(el.therapeuticAreaID))
			.map((el, i) => {
				return { key: i, value: el.therapeuticAreaID, text: el.therapeuticArea };
			});
	};

	itemInfoExistForArea = therapeuticAreaID => {
		if (!therapeuticAreaID) return;
		let itemInfo = _.find(this.itemInfors, el => el.therapeuticAreaID === therapeuticAreaID);
		return itemInfo ? true : false;
	};

	loadPracticePrograms = async () => {
		this.practicePrograms = await API.get(
			`/PracticePrograms?filter=${JSON.stringify({
				fields: {
					id: false,
					practiceID: true,
					programID: true,
					created: false,
					modified: false
				}
			})}`
		);
	};

	loadItemInfos = async () => {
		this.itemInfors = await API.get(
			`/ItemInfors?filter=${JSON.stringify({
				where: { disabled: false },
				fields: [
					'id',
					'therapeuticAreaID',
					'itemName',
					'itemCode',
					'restrictionCode',
					'treatment',
					'indication',
					'noOfRepeats',
					'programID',
					'quantity',
					'api'
				]
			})}`
		);
		this.iis = this.itemInfors.map(el => {
			return {
				id: el.id,
				therapeuticAreaID: el.therapeuticAreaID,
				itemName: el.itemName,
				indication: el.indication,
				programID: el.programID,
				treatment: el.treatment
			};
		});
	};

	fetchItemInfoDesc = async () => {
		const { therapeuticAreaValue, indicationValue } = this;
		if (!therapeuticAreaValue || !indicationValue) return;
		const fetched = await ItemInfor.fetchMoreByAreaIndication(
			therapeuticAreaValue,
			indicationValue
		);
		if (fetched && fetched.length) {
			this.iisDesc = fetched;
		}
	};

	onClose = id => {
		const manual = this.rx.manual;
		this.resetForm();
		this.props.onRequestClose(manual, id);
	};

	initForm = () => {
		this.msgStore.clear();
		this.setStoredFiles();
	};

	setStoredFiles = () => {
		let files = [];
		const { rx } = this;
		let order, label, lastPart, lastPartNumber;
		for (let i = 0; i < 5; i++) {
			const file = rx[`fileMan${i + 1}`];
			if (file) {
				order = 0;
				label = file.substring(file.lastIndexOf('/') + 1);
				lastPart = file.substring(file.lastIndexOf('_') + 1);
				lastPart = lastPart
					.split('.')
					.slice(0, -1)
					.join('.');
				lastPartNumber = Number(lastPart);
				if (!isNaN(lastPartNumber)) {
					order = lastPartNumber;
				}
				files.push({
					fileName: file,
					label: label,
					order: order,
					deleted: false
				});
			}
		}
		files = _.orderBy(files, ['order']);
		this.storedFiles = files;
	};

	componentDidMount = async () => {
		this.resetForm();
		await this.fetchLists();
	};

	componentDidUpdate = async prevProps => {
		if (this.props.isOpen && !prevProps.isOpen) {
			this.loading = true;
			this.resetForm();
			if (this.props.scriptId !== prevProps.scriptId) await this.fetchLists();
			this.setSingleTherapeuticArea();
			if (this.props.scriptId) {
				await this.loadRx();
			} else {
				// this.rx.dose = 'D';
				this.doseDdlValue = 'D';
				this.showButtons = true;
				this.loading = false;
			}
		}
	};

	fetchLists = async () => {
		if (this.prescriberAll.length === 0 || this.therapeuticAreas.length === 0) {
			await this.loadDropdownLists();
		}
	};

	resetForm = async () => {
		this.rx = new Rx();

		this.rx.status = 'new';
		this.rx.treatmentType = '';

		this.prescriberId = 0;
		this.practiceId = 0;
		this.programIds = [];

		this.therapeuticAreaValue = 0;
		this.drugValue = '';
		this.indicationValue = '';
		this.itemInforValue = null;
		this.itemInforEdit = false;
		this.itemInforEditValues = [];
		this.drugs = [];
		this.indications = [];
		this.treatmentTypes = [];

		this.active = {};
		this.responseData = '';
		this.assessmentDetailsText = '';
		this.perDayValue = '';
		this.doseDdlValue = 'D';
		this.showDebug = false;
		this.debugIdx = -1;
		this.showPatientDetails = false;
		this.showIHICheckDlg = false;
		this.showResponseMsg = false;
		this.hideRx = false;
		this.manualUploadSwitch = false;

		this.isLoadingPatientSearch = false;
		this.isLoadingIHICheck = false;
		this.showButtons = false;
		this.editNotesMode = false;
		this.storedFiles = [];
		this.filesToUpload.clear();
		this.msgStore.clear();
	};

	onChangeReset = val => {
		const { rx } = this;
		rx.noOfRepeats = '';
		rx.treatmentType = '';
		rx.quantity = '';
		this.itemInforValue = new ItemInfor();
		this.itemInforEdit = false;
		this.itemInforEditValues = [];
		if (val === 'drugName') return;
		this.drugValue = '';
		this.drugs = [];
		if (val === 'indication') return;
		this.indicationValue = '';
		this.indications = [];
		this.programIds = [];
		if (val === 'practice') return;
		this.practiceId = 0;
		this.practices = [];
		if (val === 'prescriber') return;
		this.prescriberId = 0;
		this.prescribers = [];
	};

	onChangeFile = () => {
		const storedNotDeleted = this.storedFiles.filter(f => !f.deleted).length;
		const filesToUploadReady = this.filesToUpload.length;
		const fileInput = this.uploadInput.current;
		const files = fileInput ? fileInput.files : null;
		const currentLength = storedNotDeleted + filesToUploadReady;

		if (!files || !files.length || currentLength >= 5) {
			this.uploadInput.current.value = null;
			return;
		}

		let filesLength = files.length;
		if (currentLength + filesLength > 5) {
			filesLength = 5 - currentLength;
		}
		for (let i = 0; i < filesLength; i++) {
			this.filesToUpload.push(new File(files[i]));
		}
		this.uploadInput.current.value = null;
	};

	removeDuplicates = (myArr, prop) => {
		return myArr.filter((obj, pos, arr) => {
			return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
		});
	};

	dataValidationSchemaSearch = yup.object().shape({
		patientMedicare: yup
			.number()
			.label('Medicare Number')
			.required("Please enter Patient's medicare number.")
			.typeError('Medicare Number must be a number.')
			.test('len', 'Medicare Number must be 11 digits.', val =>
				val ? val.toString().length === 11 : true
			)
	});

	dataValidationSchema = yup.object().shape({
		patientMedicare: yup
			.number()
			.label('Medicare Number')
			.required()
			.typeError('Medicare Number must be a number.')
			.test('len', 'Medicare Number must be 11 digits.', val =>
				val ? val.toString().length === 11 : true
			),
		patientName: yup
			.string()
			.label('Patient Name')
			.required(),
		patientSurname: yup
			.string()
			.label('Patient Surname')
			.required(),
		prescriberId: yup
			.number()
			.positive('Prescriber is a required field.')
			.typeError('Prescriber is a required field.')
			.required('Prescriber is a required field.'),
		practiceId: yup
			.number()
			.positive('Practice is a required field.')
			.typeError('Practice is a required field.')
			.required('Practice is a required field.'),
		authorityNo: yup
			.string()
			.label('Authority Number')
			.required()
			.typeError('Authority Number must be a number.')
			.test('len', 'Authority Number must be a valid authority number.', val => {
				const l = val.length;
				if (l < 2 || l > 8) return false;
				const first = val.slice(0, l - 1);
				const total = first
					.toString()
					.split('')
					.map(Number)
					.reduce(function(a, b) {
						return a + b;
					}, 0);
				const remainder = total % 9;
				const checkDigit = Number(val.slice(-1));
				return remainder === checkDigit;
			}),
		therapeuticArea: yup
			.number()
			.positive('Therapeutic Area is a required field.')
			.typeError('Therapeutic Area is a required field.')
			.required('Therapeutic Area is a required field.'),
		rxDate: yup
			.date()
			.label('Script Date')
			.typeError('Script Date is a required field.')
			.required('Script Date is a required field.'),
		drug: yup
			.string()
			.label('Drug')
			.required(),
		treatmentType: yup
			.string()
			.label('Treatment')
			.required('Treatment is a required field.'),
		indication: yup
			.string()
			.label('Indication')
			.required('Indication is a required field.'),
		itemInfoID: yup
			.string()
			.required(
				'The selected combination of Therapeutic Area, Drug, Treatment, and Indication is not valid.'
			),
		eye: yup
			.string()
			.label('Eye')
			.when('therapeuticArea', {
				is: 1,
				then: yup.string().required()
			}),
		noOfRepeats: yup
			.number()
			.label('Number of Repeats')
			.typeError('Number of Repeats is a required field.')
			.required(),
		filesToUploadLength: yup
			.number()
			.label('Attach File')
			.typeError('Attach File is required. Please attach a file.')
			.when('manual', {
				is: true,
				then: yup.number().positive('Attach File is required. Please attach a file.')
			}),
		dose: yup
			.string()
			.required('"Per day" is a required field.')
			.when('isPerDay', {
				is: true,
				then: yup
					.string()
					.required('"Per day" is a required field.')
					.test(
						'len',
						'Dose value must have up to 6 numeric or alpha characters',
						val => val.toString().length < 7
					)
			})
	});

	saveNotes = async () => {
		const { uiShared } = this.props;
		try {
			this.msgStore.clear();
			uiShared.showSpinner('Saving...');
			await this.rx.update();
			await this.props.onRequestReload();
			this.editNotesMode = false;
		} catch (e) {
			this.msgStore.setError(e);
		} finally {
			uiShared.hideModal();
		}
	};

	deleteRx = async () => {
		const { uiShared } = this.props;
		try {
			this.msgStore.clear();
			uiShared.showSpinner('Deleting...');
			const rx = await Rx.loadById(this.props.scriptId);
			rx.disabled = true;
			await rx.update();
			await this.props.onRequestReload();
			this.onClose();
		} catch (e) {
			this.msgStore.setError(e);
		} finally {
			uiShared.hideModal();
		}
	};

	save = async shouldExit => {
		const { uiShared, onRequestReload } = this.props;
		const { rx, onClose, pps, practiceId, prescriberId, isConfirmed } = this;
		try {
			this.msgStore.clear();
			uiShared.showSpinner('Saving...');
			const pp = _.find(
				pps,
				pp => pp.prescriberID === prescriberId && pp.practiceID === practiceId
			);
			this.rx.prescriberPracticeID = pp?.id;

			this.rx.indication = this.indicationValue;
			this.rx.drug = this.drugValue;
			this.rx.itemCode = this.itemInforValue?.itemCode;
			//reset questions and status if itemInfoID changes
			if (this.rx.itemInfoID && this.rx.itemInfoID !== this.itemInforValue?.id) {
				this.rx.questions = '';
				this.rx.status = 'new';
			}
			this.rx.itemInfoID = this.itemInforValue?.id;
			this.rx.dose = this.doseDdlValue === '-' ? this.perDayValue : this.doseDdlValue;
			let validationData = Object.assign({}, rx, rx.Patient, {
				therapeuticArea: this.therapeuticAreaValue,
				prescriberId: this.prescriberId,
				practiceId: this.practiceId,
				isPerDay: this.doseDdlValue === '-'
			});
			if (rx.manual) {
				validationData.filesToUploadLength =
					this.storedFiles.filter(f => !f.deleted).length + this.filesToUpload.length;
			}
			await this.dataValidationSchema.validate(toJS(validationData), {
				abortEarly: false
			});
			this.rx.Patient.patientName = rx.Patient.patientName?.trimRight();
			this.rx.Patient.patientSurname = rx.Patient.patientSurname?.trimRight();
			let data = JSON.parse(JSON.stringify(toJS(rx).Patient));
			const patientMatch = await Patient.searchByMedicareNo(rx.Patient.patientMedicare);
			if (patientMatch?.length === 1) {
				data.id = patientMatch[0].id;
				data.modified = new Date();
			} else {
				data.id = null;
			}
			const toUpdate = new Patient(data);
			await toUpdate.update();
			this.rx.patientID = toUpdate.id;
			await rx.update();

			const filesToRemove = this.storedFiles.filter(f => f.deleted);
			if (this.filesToUpload.length > 0 || filesToRemove.length > 0) {
				await rx.reload();
				//consolidate names
				const takenNames = this.storedFiles.filter(f => !f.deleted).map(f => f.fileName);
				const takenIds = [];
				takenNames.forEach(n => {
					let lastPart = n.substring(n.lastIndexOf('_') + 1);
					lastPart = lastPart
						.split('.')
						.slice(0, -1)
						.join('.');
					const lastPartNumber = Number(lastPart);
					if (!isNaN(lastPartNumber)) {
						takenIds.push(lastPartNumber);
					}
				});
				takenIds.sort((a, b) => {
					return a - b;
				});

				if (takenNames.length > takenIds.length) {
					takenIds.push(1);
				}
				const available = [];
				for (let i = 0; i < 5; i++) {
					if (takenIds.indexOf(i + 1) === -1) {
						available.push(i + 1);
					}
				}
				//prepare new names
				const ph = `${rx.searchPrescriber}_${rx.Patient.patientName}_${rx.Patient.patientSurname}_${
					rx.indication
				}Manual_ID${rx.id}`;
				const uploadCount = this.filesToUpload.length;
				if (uploadCount > 0) {
					for (let i = 0; i < uploadCount; i++) {
						const f = this.filesToUpload[i];
						const idx = i + 1;
						const isTaken = takenIds.indexOf(idx) !== -1;
						let num;
						if (isTaken) {
							num = available.shift();
							takenIds.push(num);
						} else {
							num = `${idx}`;
						}

						const isSingleFile =
							uploadCount === 1 && this.storedFiles.filter(f => !f.deleted).length === 0;
						const suffix = isSingleFile ? '' : `_0${num}`;

						const ext = f.name.substring(f.name.lastIndexOf('.') + 1);
						f.name = `${ph}${suffix}.${ext}`;
					}
				}

				//upload files
				const promises = this.filesToUpload.map(f => this.rx.updateRx(f.file, f.name));
				const uploadedRes = await Promise.all(promises);

				//updateSet(update db)
				const storedSet = this.storedFiles.filter(f => !f.deleted).map(f => f.fileName);
				const newSet = this.filesToUpload.map((f, i) => {
					return uploadedRes[i].fileName;
				});

				const updateSet = storedSet.concat(newSet);

				const updateData = {};
				for (let i = 0; i < 5; i++) {
					updateData[`fileMan${i + 1}`] = updateSet[i] ? updateSet[i] : '';
				}

				await rx.setAttributes(updateData);
			}
			await onRequestReload();
			if (shouldExit) {
				onClose();
			} else {
				onClose(this.rx.id);
			}
		} catch (e) {
			this.msgStore.setError(e);
		} finally {
			uiShared.hideModal();
		}
	};

	call = async () => {
		this.showResponseMsg = false;
		const { inputParamsValue, inputJsonValue } = this;
		const { name, json } = this.active;
		const body = json ? inputJsonValue : { inputParams: encodeURI(inputParamsValue.trim()) };
		const ext = { rxId: this.rx?.id };
		let req = {
			name,
			body,
			ext
		};
		let response = await Rx.callProda(req);
		this.responseData = toJS(response);
		if (this.responseData.statusMessages?.length > 0 || this.responseData.code) {
			this.showDebug = true;
		}
	};

	enquireAuthority = async () => {
		const { uiShared } = this.props;
		const { rx } = this;
		try {
			this.msgStore.clear();
			uiShared.showSpinner('Loading...');
			const cmd = this.commands.find(c => c.name === 'enquireAuthority');
			this.setActive(cmd);
			const prescriberID = toJS(rx).PrescriberPractice.Prescriber.prescriberNo;
			const authorityPrescriptionNumber = rx.authorityNo;
			const authorityUniqueId = rx.authorityUniqueID;
			if (!authorityUniqueId) {
				throw Error('Missing authorityUniqueId. Contact an administrator.');
			}
			this.inputParamsValue = `${prescriberID.trim()}/${authorityPrescriptionNumber?.trim()}/${authorityUniqueId.trim()}`;
			await this.call();
			this.showDebug = true;
			this.debugIdx = -1;
			this.hideRx = true;
		} catch (e) {
			this.msgStore.setError(e);
		} finally {
			uiShared.hideModal();
		}
	};

	cancelAuthority = async () => {
		const { uiShared } = this.props;
		const { rx } = this;
		try {
			this.msgStore.clear();
			uiShared.showSpinner('Requesting...');
			const cmd = this.commands.find(c => c.name === 'cancelAuthority');
			this.setActive(cmd);
			const prescriberID = toJS(rx).PrescriberPractice.Prescriber.prescriberNo;
			const authorityPrescriptionNumber = rx.authorityNo;
			const authorityUniqueId = rx.authorityUniqueID;
			if (!authorityUniqueId) {
				throw Error('Missing authorityUniqueId. Contact an administrator.');
			}
			this.inputParamsValue = `${prescriberID.trim()}/${authorityPrescriptionNumber?.trim()}/${authorityUniqueId.trim()}`;
			console.log(this.inputParamsValue);
			await this.call();

			const isCancelled =
				this.responseData.statusMessages &&
				this.responseData.statusMessages[0]?.reasonText?.trim() ===
					'Authority application has successfully been cancelled';
			if (isCancelled) {
				await this.saveCancelResponse();
				this.showResponseMsg = true;
				this.debugIdx = -1;
			} else {
				this.showDebug = true;
				this.debugIdx = 0;
			}
		} catch (e) {
			this.msgStore.setError(e);
		} finally {
			uiShared.hideModal();
		}
	};

	saveCancelResponse = async () => {
		const { uiShared, onRequestReload } = this.props;
		const { rx, responseData } = this;
		try {
			this.msgStore.clear();
			rx.status = 'cancelled';
			rx.authorityUniqueID = responseData.authorityUniqueId;
			rx.finalisationDate = new Date();
			await rx.update();
			await Promise.all([rx.reload(), onRequestReload()]);
		} catch (e) {
			this.msgStore.setError(e);
		} finally {
			uiShared.hideModal();
		}
	};

	renderButtons = (readOnly, isManualReadOnly) => {
		if (!this.showButtons) return;
		const { rx } = this;
		const status = rx.status;
		let btn = [];
		if (isManualReadOnly) {
			btn.push(this.renderModify());
			return btn;
		}
		if (readOnly) {
			if (status == 'approved') {
				btn.push(this.renderCancel());
			}
		} else {
			if (this.rx.manual) {
				btn.push(this.renderUploadBtn());
			}
			if (status == 'rejected') {
				// if (rx.overridable) {
				// 	btn.push(this.renderUpdate());
				// }
			} else {
				btn.push(this.renderContinue());
				btn.push(this.renderSaveAndExit());
			}
		}
		if (!rx.manual && ['approved', 'cancelled', 'rejected'].includes(rx?.status))
			btn.push(this.renderEnquire());
		return btn;
	};

	renderModify = () => {
		return (
			<Button
				primary
				onClick={async () => {
					this.props.onRequestModify(this.rx.id);
				}}
				key="modify"
			>
				Modify
			</Button>
		);
	};

	renderEnquire = () => {
		return (
			<Button
				onClick={() => {
					this.enquireAuthority();
				}}
				key="enquire"
			>
				Enquire
			</Button>
		);
	};

	renderContinue = () => {
		return (
			<Button
				primary
				onClick={() => {
					this.save();
				}}
				className={styles.greenButton}
				key="continue"
			>
				Continue
			</Button>
		);
	};

	renderUploadBtn = () => {
		const self = this;
		return (
			<Fragment>
				<Button
					primary
					required
					icon="upload"
					onClick={() => {
						self.uploadInput.current.click();
					}}
					label="Attach File"
					icon="upload"
				/>
				<input ref={this.uploadInput} type="file" multiple hidden onChange={this.onChangeFile} />
			</Fragment>
		);
	};

	renderSaveAndExit = () => {
		return (
			<Button
				primary
				onClick={() => {
					this.save(true);
				}}
				key="saveExit"
			>
				Save & Exit
			</Button>
		);
	};

	renderCancel = () => {
		return (
			<Button
				primary
				onClick={() => {
					this.showCancelConfirmDlg = true;
				}}
				key="cancel"
				className={styles.redButton}
			>
				Cancel
			</Button>
		);
	};

	renderUpdate = () => {
		return (
			<Button
				primary
				onClick={() => {
					this.save();
				}}
				primary
				key="update"
			>
				Update
			</Button>
		);
	};

	renderDelete = () => {
		return (
			<Button
				primary
				onClick={() => {
					this.showDeleteConfirmDlg = true;
				}}
				key="delete"
				formNoValidate={true}
				className={styles.redButton}
			>
				Delete Rx
			</Button>
		);
	};

	renderDebug = () => {
		const { responseData, debugIdx } = this;
		return (
			<Accordion>
				<Accordion.Title active={debugIdx === 0} index={0} onClick={this.handleDebugClick}>
					<Icon name="dropdown" />
					DETAILS
				</Accordion.Title>
				<Accordion.Content active={debugIdx === 0}>
					<Segment className={styles.debugCnt}>
						{responseData && this.prettyPrintJson(responseData)}
					</Segment>
				</Accordion.Content>
			</Accordion>
		);
	};

	handleDebugClick = (e, titleProps) => {
		const { index } = titleProps;
		const { debugIdx } = this;
		const newIndex = debugIdx === index ? -1 : index;
		this.debugIdx = newIndex;
	};

	prettyPrintJson = data => (
		<div>
			<pre className={styles.pre}>{JSON.stringify(data, null, 2)}</pre>
		</div>
	);

	renderResponseMsg = () => {
		const statusMessage =
			this.responseData?.statusMessages && this.responseData.statusMessages[0]?.reasonText?.trim();
		return (
			<div className={styles.resultReasonCnt}>
				<h3>{statusMessage}</h3>
			</div>
		);
	};

	renderEnquireTable = () => {
		const r = this.responseData;
		return (
			<Table>
				<Table.Header>
					<Table.Row>
						<Table.HeaderCell width={6}>Name</Table.HeaderCell>
						<Table.HeaderCell>Value</Table.HeaderCell>
					</Table.Row>
				</Table.Header>
				<Table.Body>
					<Table.Row key={1}>
						<Table.Cell>Authority Prescription Number</Table.Cell>
						<Table.Cell>{r.authorityPrescriptionNumber}</Table.Cell>
					</Table.Row>
					<Table.Row key={2}>
						<Table.Cell>Prescriber Id</Table.Cell>
						<Table.Cell>{r.prescriberId}</Table.Cell>
					</Table.Row>
					<Table.Row key={3}>
						<Table.Cell>Medicare Number</Table.Cell>
						<Table.Cell>{r.patientDetails?.medicareNumber}</Table.Cell>
					</Table.Row>
					<Table.Row key={4}>
						<Table.Cell>First Name</Table.Cell>
						<Table.Cell>{r.patientDetails?.firstName}</Table.Cell>
					</Table.Row>
					<Table.Row key={5}>
						<Table.Cell>Surname</Table.Cell>
						<Table.Cell>{r.patientDetails?.surname}</Table.Cell>
					</Table.Row>
					<Table.Row key={6}>
						<Table.Cell>Code</Table.Cell>
						<Table.Cell>{r.itemDetails?.code}</Table.Cell>
					</Table.Row>
					<Table.Row key={7}>
						<Table.Cell>Brand</Table.Cell>
						<Table.Cell>{r.itemDetails?.brand}</Table.Cell>
					</Table.Row>
					<Table.Row key={8}>
						<Table.Cell>Quantity</Table.Cell>
						<Table.Cell>{r.itemDetails?.quantity}</Table.Cell>
					</Table.Row>
					<Table.Row key={9}>
						<Table.Cell>Number Of Repeats</Table.Cell>
						<Table.Cell>{r.itemDetails?.numberOfRepeats}</Table.Cell>
					</Table.Row>
					<Table.Row key={10}>
						<Table.Cell>Dose</Table.Cell>
						<Table.Cell>{r.itemDetails?.dose}</Table.Cell>
					</Table.Row>
					<Table.Row key={11}>
						<Table.Cell>Assessment Details</Table.Cell>
						<Table.Cell>{r.assessmentDetails?.text}</Table.Cell>
					</Table.Row>
					{r.authorityApprovalNumber && (
						<Table.Row key={12}>
							<Table.Cell>Authority Approval Number</Table.Cell>
							<Table.Cell>{r.authorityApprovalNumber}</Table.Cell>
						</Table.Row>
					)}
				</Table.Body>
			</Table>
		);
	};

	handlePatientDetailsClick = () => {
		this.showPatientDetails = !this.showPatientDetails;
	};

	setDefaulItemInfoValues = () => {
		const { itemInforValue, rx } = this;
		if (!rx.noOfRepeats && !isNaN(itemInforValue?.noOfRepeats)) {
			this.rx.noOfRepeats = Number(itemInforValue.noOfRepeats);
		}
		if (!isNaN(itemInforValue?.quantity) && this.therapeuticAreaValue !== 1) {
			this.rx.quantity = Number(itemInforValue.quantity);
		}
	};

	setSingleTherapeuticArea = () => {
		if (this.therapeuticAreas.length === 1) {
			this.therapeuticAreaValue = this.therapeuticAreas[0].value;
			this.getPrescribers();
		}
	};

	setSinglePrescriber = () => {
		if (this.prescribers.length === 1) {
			this.prescriberId = this.prescribers[0].value;
			this.getPractices();
		}
	};

	setSinglePractice = () => {
		if (!this.therapeuticAreaValue) return;
		const filteredPractices = this.pps.filter(
			pp =>
				pp.prescriberID === this.prescriberId && pp.therapeuticAreaID === this.therapeuticAreaValue
		);
		if (filteredPractices.length === 1) {
			this.practiceId = filteredPractices[0].practiceID;
			this.setProgramIds();
			this.getIndications();
		}
	};

	setSingleIndication = () => {
		if (this.indications?.length === 1) {
			this.indicationValue = this.indications[0].value;
			this.getDrugs();
		}
	};

	setProgramIds = () => {
		if (!this.practiceId) return;
		const { practicePrograms } = this;
		this.programIds = practicePrograms
			.filter(val => val.practiceID === this.practiceId)
			.map(val => val.programID);
	};

	getIndications = () => {
		let indications = [];
		const { therapeuticAreaValue, practiceId, iis, removeDuplicates } = this;
		if (therapeuticAreaValue && practiceId) {
			indications = iis.filter(el => el.therapeuticAreaID === therapeuticAreaValue);
			indications = removeDuplicates(indications, 'indication');
			indications = indications.map(el => el.indication);
			const first = ORDERED.filter(v => indications.includes(v));
			const rest = indications.filter(v => !first.includes(v));
			const restSorted = this.sortObjects(rest, 'value');
			const sorted = first.concat(restSorted);
			indications = sorted.map((el, idx) => ({
				key: idx,
				value: el,
				text: el
			}));
		}
		this.indications = indications;
		this.setSingleIndication();
	};

	getPrescribers = () => {
		if (this.therapeuticAreaValue) {
			const prescribersByArea = this.prescriberAll.filter(
				el => el.therapeuticAreaID === this.therapeuticAreaValue
			);
			const prescrNoDuplicates = this.removeDuplicates(prescribersByArea, 'prescriberNo');
			this.prescribers = prescrNoDuplicates.map(el => {
				return {
					key: el.id,
					value: el.id,
					text: `${el.prescriberName} ${el.prescriberSurname} / ${el.prescriberNo}`
				};
			});
		}
		this.setSinglePrescriber();
	};

	getPractices = () => {
		const { practiceAll } = this;
		this.practices = this.pps
			.filter(
				pp =>
					pp.prescriberID === this.prescriberId &&
					pp.therapeuticAreaID === this.therapeuticAreaValue
			)
			.map(el => {
				const practice = _.find(practiceAll, p => p.id == el.practiceID);
				return {
					key: practice.id,
					value: practice.id,
					text: practice.practiceName
				};
			});
		this.setSinglePractice();
	};

	getDrugs = () => {
		if (!this.indicationValue) return;
		if (this.programIds?.length < 1) this.setProgramIds();
		const { iis, removeDuplicates, programIds } = this;
		let drugsArr = iis.filter(
			el =>
				el.indication === this.indicationValue &&
				el.therapeuticAreaID === this.therapeuticAreaValue &&
				programIds.includes(el.programID)
		);
		drugsArr = removeDuplicates(drugsArr, 'itemName');
		const unsorted = drugsArr.map(el => ({
			key: el.id,
			value: el.itemName,
			text: el.itemName
		}));
		this.drugs = this.sortObjects(unsorted, 'value');
		this.setSingleDrug();
	};

	setSingleDrug = () => {
		if (this.drugs.length === 1) {
			this.drugValue = this.drugs[0].value;
			this.getTreatmentPhases();
		}
	};

	getTreatmentPhases = () => {
		if (!this.drugValue) return;
		const { iis, indicationValue, therapeuticAreaValue, drugValue, programIds } = this;
		let tt = iis.filter(
			el =>
				el.indication === indicationValue &&
				el.therapeuticAreaID === therapeuticAreaValue &&
				el.itemName === drugValue &&
				_.includes(programIds, el.programID)
		);
		tt = this.removeDuplicates(tt, 'treatment');
		const unsorted = tt.map(el => ({
			key: el.id,
			value: el.treatment,
			text: el.treatment
		}));
		this.treatmentTypes = this.sortObjects(unsorted, 'value');
		this.setSingleTreatmentPhase();
	};

	setSingleTreatmentPhase = async () => {
		if (this.treatmentTypes.length === 1) {
			this.rx.treatmentType = this.treatmentTypes[0].value;
		}
		await this.setValueROFields();
	};

	setQuantityValue = () => {
		const { rx, therapeuticAreaValue, therapeuticAreas } = this;
		if (!therapeuticAreaValue) return;
		let quantity;
		const ophthalmologyArea = _.find(toJS(therapeuticAreas), el => el.text === 'OPHTHALMOLOGY');
		const ophthalmoSelected = ophthalmologyArea && therapeuticAreaValue === ophthalmologyArea.value;
		if (ophthalmoSelected) {
			if (rx.eye) {
				quantity = this.rx.eye == 'BOTH' ? 2 : 1;
			}
		} else {
			if (this.itemInforValue) {
				quantity = this.itemInforValue?.quantity;
			}
		}
		if (quantity) {
			this.rx.quantity = quantity;
		}
	};

	setValueROFields = async itemCode => {
		if (!this.itemInfors?.length) return;
		const { therapeuticAreaValue, indicationValue, drugValue, rx, programIds } = this;
		const treatmentType = rx.treatmentType;
		if (!therapeuticAreaValue || !indicationValue || !drugValue || !treatmentType) {
			this.itemInforValue = new ItemInfor();
			return;
		}
		let itemInfo = _.filter(
			this.itemInfors,
			el =>
				el.therapeuticAreaID === therapeuticAreaValue &&
				el.itemName === drugValue &&
				el.treatment === treatmentType &&
				el.indication === indicationValue &&
				_.includes(programIds, el.programID)
		);

		if (itemInfo.length) {
			if (itemInfo.length > 1 && !itemCode) {
				this.itemInforEdit = true;
				this.itemInforEditValues = itemInfo.map(ii => {
					return { text: ii.itemCode, value: ii.itemCode };
				});
			} else {
				let val;
				if (itemInfo.length > 1) {
					val = _.find(itemInfo, el => el.itemCode === itemCode);
				} else {
					val = itemInfo[0];
				}
				if (val) {
					let item = _.find(this.iisDesc, el => el.id === val.id);
					if (!item) {
						item = await ItemInfor.loadById(Number(val.id));
					}
					val.restrictionText = item.restrictionText;
					val.increaseRepeats = item.increaseRepeats;
					val.unit = item.unit;
					val.maxQuantityPacks = item.maxQuantityPacks;
					val.maxQuantityUnits = item.maxQuantityUnits;
					this.itemInforValue = val;
					this.setQuantityValue();
					this.setDefaulItemInfoValues();
					this.setManualUploadSwitch();
				}
			}
		}
	};

	setManualUploadSwitch = () => {
		if (!this.itemInforValue?.id || !this.therapeuticAreaValue) return;
		const { prescriberId, itemInforValue } = this;
		if (prescriberId && itemInforValue?.id) {
			const p = _.find(this.prescriberAll, {
				id: this.prescriberId,
				therapeuticAreaID: this.therapeuticAreaValue
			});
			const previousSwitchState = !!this.manualUploadSwitch;
			this.manualUploadSwitch = !!(p.api && itemInforValue.api);
			if (!previousSwitchState && this.manualUploadSwitch) {
				this.rx.manual = false;
				return;
			}
			if (!p.api) {
				this.rx.manual = true;
			} else if (p.api && !itemInforValue.api) {
				this.rx.manual = true;
			}
		}
	};

	searchPatient = async () => {
		this.msgStore.clear();
		try {
			await this.dataValidationSchemaSearch.validate(toJS(this.rx.Patient), {
				abortEarly: false
			});
			const { rx } = this;
			const { patientMedicare } = rx.Patient;
			const searchValue = patientMedicare;
			this.isLoadingPatientSearch = true;
			const patient = await Patient.searchByMedicareNo(patientMedicare);
			this.isLoadingPatientSearch = false;
			if (patient?.length === 1) {
				const res = patient[0];
				rx.Patient = new Patient(res);
				rx.Patient.patientMedicare = searchValue;
				//IHI UI disabled
				// this.showIHICheckDlg = res.patientSurname && res.patientDOB ? true : false;
			} else {
				this.msgStore.setInfo('No match found, add patient’s details');
			}
		} catch (err) {
			this.msgStore.setError(err);
		} finally {
			this.isLoadingPatientSearch = false;
		}
	};

	execIhiCheck = async () => {
		const { rx } = this;
		const { patientMedicare, patientSurname, patientName, patientDOB } = rx.Patient;
		if (!patientMedicare || !patientSurname || !patientDOB) return;
		let dob = new Date(patientDOB);
		const timeZoneOffset = dob.getTimezoneOffset();
		const minutes = timeZoneOffset * -1;
		const adjusted = new Date(dob.getTime() + minutes * 60000);
		const adjustedISO = adjusted.toISOString();
		let val = adjustedISO.substring(0, 10).split('-');
		try {
			this.msgStore.clear();
			this.isLoadingIHICheck = true;
			let req = {
				body: {
					medicareCardNumber: patientMedicare.substring(0, 10),
					medicareIRN: patientMedicare.substring(10, 11),
					familyName: patientSurname,
					dateOfBirth: `${val[2]}/${val[1]}/${val[0]}`
				}
			};
			if (patientName) {
				req.body.givenName = patientName;
			}
			const res = await Patient.callIhi(req);
			const result = res.result;
			if (res.error && Array.isArray(res.error) && res.error.length > 0) {
				let msg = '';
				res.error.forEach(e => {
					msg = `${msg}${e.substring(e.indexOf('(ERROR)') + 8)} `;
				});
				if (!msg)
					msg =
						'There was an error. Please try IHI check again later. If a problem persists please contact an administrator.';
				this.msgStore.setError(msg);
			} else if (result.ihiNumber) {
				const data = {
					patientMedicare,
					ihi: '',
					recordStatus: '',
					ihiStatus: ''
				};
				const index = result.ihiNumber.lastIndexOf('/');
				data.ihi = result.ihiNumber.substring(index + 1);
				this.rx.Patient.ihi = data.ihi;
				if (result.ihiRecordStatusSpecified) {
					data.recordStatus = result.ihiRecordStatus;
					this.rx.Patient.recordStatus = data.recordStatus;
				}
				if (result.ihiStatusSpecified) {
					data.ihiStatus = result.ihiStatus;
					this.rx.Patient.ihiStatus = data.ihiStatus;
				}
				this.isLoadingIHICheck = false;
				await Patient.updateIhi(data);
			} else {
				this.msgStore.setInfo('IHI record was not found.');
			}
		} catch (e) {
			this.msgStore.setError(e);
		} finally {
			this.isLoadingIHICheck = false;
		}
	};

	renderIHIInfo = () => {
		const { ihi, ihiStatus, recordStatus } = this.rx?.Patient;
		return (
			<div className={styles.ihiRow}>
				<strong>IHI:</strong> {ihi}
				<br />
				<strong>IHI Status:</strong> {ihiStatus}
				<br />
				<strong>Record Status:</strong> {recordStatus}
				<br />
			</div>
		);
	};

	populateNumberDdl = (arr, from, to) => {
		if (!arr || isNaN(from)) return;
		if (!to) {
			return arr.push({ key: from, value: from, text: from });
		}
		const valid = !isNaN(to) && to > from;
		if (!valid) return;
		let x = from;
		const y = to + 1;
		while (y !== x) {
			arr.push({ key: x, value: x, text: x });
			x++;
		}
	};

	render() {
		const { isOpen, scriptId, auth } = this.props;
		const {
			rx,
			prescribers,
			practices,
			therapeuticAreaValue,
			therapeuticAreas,
			treatmentTypes,
			drugValue,
			indications,
			drugs,
			indicationValue,
			isLoadingPatientSearch,
			isLoadingIHICheck,
			itemInforValue,
			loading,
			showDebug,
			showResponseMsg,
			hideRx,
			renderResponseMsg,
			renderEnquireTable,
			renderDebug,
			onClose,
			showPatientDetails,
			editNotesMode,
			manualUploadSwitch,
			storedFiles,
			filesToUpload,
			itemInforEdit,
			itemInforEditValues
		} = this;
		const self = this;
		const isViewer = auth?.user?.role === 'viewer';
		let isReadOnly = isViewer || ['approved', 'cancelled'].includes(rx?.status);
		let showDelete = !loading && !isViewer && scriptId && ['new', 'pending'].includes(rx?.status);
		const buttonsVisible = !isViewer && !hideRx;
		if (rx && rx.status === 'rejected' && !rx.overridable) {
			isReadOnly = true;
		}
		let isManualReadOnly = false;
		if (rx?.manual && !isViewer) {
			if (['approved', 'rejected', 'deferred'].includes(rx?.status)) {
				isManualReadOnly = true;
				showDelete = true;
			}
			isReadOnly = isManualReadOnly;
		}
		const showEditNotes =
			!isViewer && ['approved', 'cancelled', 'rejected'].includes(rx?.status) && !rx.manual;

		let headerTitle = '';
		if (scriptId && rx?.authorityNo) {
			headerTitle = `${rx?.searchPrescriber} - ${rx?.searchPatientName} - ${rx?.authorityNo}`;
		}
		if (!scriptId) {
			headerTitle = 'New RX Details';
		}
		const ph = <span className={styles.ph}>-</span>;
		const stored = storedFiles.filter(f => !f.deleted);

		let numberRepeats = [];
		if (!isNaN(itemInforValue?.noOfRepeats)) {
			const increase = !isNaN(itemInforValue?.increaseRepeats) ? itemInforValue.increaseRepeats : 0;
			const maxValue = itemInforValue?.noOfRepeats + increase;
			this.populateNumberDdl(numberRepeats, 0, maxValue);
		}

		const quantities = [];
		if (!isNaN(itemInforValue?.quantity) && this.therapeuticAreaValue !== 1) {
			const quantity = itemInforValue?.quantity;
			const maxQuantityPacks = !isNaN(itemInforValue?.maxQuantityPacks)
				? itemInforValue.maxQuantityPacks
				: itemInforValue.quantity;
			const maxUnits = quantity * maxQuantityPacks;
			for (let x = quantity; x <= maxUnits; x = x + quantity) {
				quantities.push({ key: x, value: x, text: x });
			}
		}

		let RO_thArea = '';
		if (isReadOnly) {
			const areaID = rx?.ItemInfo.therapeuticAreaID;
			RO_thArea = _.find(this.therapeuticAreas, a => a.value === areaID)?.text;
		}
		const ihiRowVisible = rx?.Patient.ihi ? true : false;
		let ihiBtnEnabled = false;
		if (rx?.Patient) {
			const { patientMedicare, patientSurname, patientDOB } = rx.Patient;
			if (
				patientMedicare &&
				patientSurname &&
				patientDOB &&
				patientMedicare.toString().length === 11
			)
				ihiBtnEnabled = true;
		}

		return (
			rx && (
				<Fragment>
					<Modal open={isOpen} size="small" onClose={onClose} closeOnDimmerClick={false}>
						<Fragment>
							<Dimmer active={loading} inverted>
								<Loader content="Loading" />
							</Dimmer>
							<Modal.Header>{headerTitle ? headerTitle : ph}</Modal.Header>
							<Modal.Content>
								<Form formNoValidate={true} autoComplete="off">
									<MessageBox msgStore={this.msgStore} />
									{ihiRowVisible && this.renderIHIInfo()}
									<div className={styles.buttonsRowSpaced}>
										<div className={styles.buttonCont}>{!!showDelete && this.renderDelete()}</div>
										<div>
											{buttonsVisible && this.renderButtons(isReadOnly, isManualReadOnly)}
											<Button onClick={onClose}>Close</Button>
										</div>
									</div>

									{showResponseMsg && renderResponseMsg()}
									{hideRx && renderEnquireTable()}
									{showDebug && renderDebug()}
									{!hideRx && (
										<Fragment>
											<Form.Group
												className={styles.formGroup}
												style={{ marginBottom: 0 }}
												formNoValidate={true}
											>
												<Form.Input
													required={!isReadOnly}
													readOnly={isReadOnly || scriptId}
													label="Medicare Number"
													value={rx.Patient.patientMedicare || ''}
													onChange={e => {
														let val = e.target.value?.trim();
														val = val.replace(/[^0-9.]/g, '');
														if (val.length > 11) return;
														this.rx.Patient.patientMedicare = val;
														self.msgStore.clear();
													}}
													width={8}
												/>
												<div className="eight wide field" style={{ display: 'flex' }}>
													{!isReadOnly && !scriptId && (
														<Fragment>
															<Button
																onClick={() => {
																	self.searchPatient();
																}}
																className={styles.buttomBtm}
																formNoValidate={true}
																loading={isLoadingPatientSearch}
															>
																Search
															</Button>
															{/*<Button*/}
															{/*	onClick={() => {*/}
															{/*		self.execIhiCheck();*/}
															{/*	}}*/}
															{/*	style={{ marginLeft: '15px' }}*/}
															{/*	className={styles.buttomBtm}*/}
															{/*	formNoValidate={true}*/}
															{/*	loading={isLoadingIHICheck}*/}
															{/*	disabled={!ihiBtnEnabled}*/}
															{/*>*/}
															{/*	IHI Check*/}
															{/*</Button>*/}
														</Fragment>
													)}
												</div>

												<Form.Input
													label="Patient's First Name"
													value={rx.Patient?.patientName || ''}
													onChange={e => {
														if (e.target.value?.trim().length > 40) return;
														this.rx.Patient.patientName = e.target.value?.toUpperCase().trimLeft();
														this.msgStore.clear();
													}}
													width={8}
													readOnly={isReadOnly || scriptId}
													required={!isReadOnly}
												/>
												<Form.Input
													label="Patient's Surname"
													value={rx.Patient?.patientSurname || ''}
													onChange={e => {
														if (e.target.value?.trim().length > 40) return;
														this.rx.Patient.patientSurname = e.target.value
															?.toUpperCase()
															.trimLeft();
													}}
													width={8}
													readOnly={isReadOnly || scriptId}
													required={!isReadOnly}
												/>
												{isReadOnly ? (
													<Form.Field width={8}>
														<label>Date of Birth</label>
														<Form.Input
															value={rx.Patient?.patientDOB?.toDate().format() || ''}
															readOnly
														/>
													</Form.Field>
												) : (
													<Form.Field width={8}>
														<label>Date of Birth</label>
														<DayPickerInput
															value={rx.Patient?.patientDOB?.toDate() || ''}
															onDayChange={day => {
																this.rx.Patient.patientDOB = day?.toISOString();
															}}
															dayPickerProps={{
																disabledDays: { after: new Date() }
															}}
														/>
													</Form.Field>
												)}
												{isReadOnly ? (
													<Form.Input label="Sex" value={rx.Patient.sex || ''} width={8} readOnly />
												) : (
													<Form.Field width={8}>
														<label>Sex</label>
														<Dropdown
															value={rx.Patient.sex || ''}
															options={sexes.map((el, idx) => {
																return { ...el, key: idx };
															})}
															onChange={(e, data) => {
																this.rx.Patient.sex = data.value;
															}}
															selection
															width={8}
														/>
													</Form.Field>
												)}
											</Form.Group>
											<Accordion>
												<Accordion.Title
													active={showPatientDetails}
													index={0}
													onClick={this.handlePatientDetailsClick}
													style={{ borderBottom: '1px solid #d3d3d3' }}
												>
													<Icon name="dropdown" />
													Patient details
												</Accordion.Title>
												<Accordion.Content active={showPatientDetails}>
													<Form.Group className={styles.formGroup} style={{ paddingTop: 0 }}>
														<Form.Input
															label="Address"
															value={rx.Patient?.patientAddress || ''}
															onChange={e => {
																this.rx.Patient.patientAddress = e.target.value;
															}}
															width={16}
															readOnly={isReadOnly}
														/>
														<Form.Input
															label="Suburb"
															value={rx.Patient?.patientSuburb || ''}
															onChange={e => {
																this.rx.Patient.patientSuburb = e.target.value?.toUpperCase();
															}}
															width={8}
															readOnly={isReadOnly}
														/>
														<Form.Input
															label="Postcode"
															value={rx.Patient?.patientPostcode || ''}
															onChange={e => {
																this.rx.Patient.patientPostcode = e.target.value?.toUpperCase();
															}}
															width={8}
															readOnly={isReadOnly}
														/>
														{isReadOnly ? (
															<Form.Input
																label="State"
																value={rx.Patient.patientState || ''}
																width={8}
																readOnly
															/>
														) : (
															<Form.Field width={8}>
																<label>State</label>
																<Dropdown
																	value={rx.Patient.patientState || ''}
																	options={states.map((el, idx) => {
																		return { ...el, key: idx };
																	})}
																	onChange={(e, data) => {
																		this.rx.Patient.patientState = data.value;
																	}}
																	selection
																	width={8}
																/>
															</Form.Field>
														)}
														{isReadOnly ? (
															<Form.Field width={8}>
																<label>Date of Birth</label>
																<Form.Input
																	value={rx.Patient?.patientDOB?.toDate().format() || ''}
																	readOnly
																/>
															</Form.Field>
														) : (
															<Form.Field width={8}>
																<label>Date of Birth</label>
																<DayPickerInput
																	value={rx.Patient?.patientDOB?.toDate() || ''}
																	onDayChange={day => {
																		this.rx.Patient.patientDOB = day?.toISOString();
																	}}
																	dayPickerProps={{
																		disabledDays: { after: new Date() }
																	}}
																/>
															</Form.Field>
														)}
														<Fragment>
															{isReadOnly ? (
																<Form.Input
																	label="Patient's Title"
																	value={rx.Patient.patientTitle || ''}
																	width={8}
																	readOnly
																/>
															) : (
																<Form.Field width={8}>
																	<label>Patient's Title</label>
																	<Dropdown
																		value={rx.Patient.patientTitle || ''}
																		options={titles.map((el, idx) => {
																			return { ...el, key: idx };
																		})}
																		onChange={(e, data) => {
																			this.rx.Patient.patientTitle = data.value;
																			this.msgStore.clear();
																		}}
																		selection
																		width={8}
																	/>
																</Form.Field>
															)}
															<div className="eight wide field"> </div>
														</Fragment>
													</Form.Group>
												</Accordion.Content>
											</Accordion>
											<Form.Group className={styles.formGroup} style={{ paddingTop: 10 }}>
												{isReadOnly ? (
													<Form.Input
														label="Therapeutic Area"
														value={RO_thArea}
														width={8}
														readOnly
													/>
												) : (
													<Form.Field width={8} required>
														<label>Therapeutic Area</label>
														<Dropdown
															options={therapeuticAreas}
															value={therapeuticAreaValue || ''}
															placeholder={'Select Therapeutic Area'}
															onChange={(e, data) => {
																this.therapeuticAreaValue = data.value;
																this.onChangeReset();
																this.getPrescribers();
															}}
															width={8}
															selection
														/>
													</Form.Field>
												)}
												{isReadOnly ? (
													<Form.Input
														label="Prescriber"
														value={
															`${rx.PrescriberPractice.Prescriber.prescriberName} ${
																rx.PrescriberPractice.Prescriber.prescriberSurname
															}` || ''
														}
														width={8}
														readOnly
													/>
												) : (
													<Form.Field width={8} required>
														<label>Prescriber</label>
														<Dropdown
															selection
															search={true}
															value={this.prescriberId || ''}
															options={prescribers}
															onChange={(e, data) => {
																this.prescriberId = data.value;
																this.onChangeReset('prescriber');
																this.getPractices();
															}}
															width={8}
															selection
														/>
													</Form.Field>
												)}
												{isReadOnly ? (
													<Form.Input
														label="Practice"
														value={`${rx.PrescriberPractice.Practice.practiceName}` || ''}
														width={16}
														readOnly
													/>
												) : (
													<Form.Field width={16} required>
														<label>Practice</label>
														<Dropdown
															selection
															search={true}
															value={this.practiceId || ''}
															options={practices}
															onChange={(e, data) => {
																this.practiceId = data.value;
																this.onChangeReset('practice');
																this.setProgramIds();
																this.getIndications();
															}}
															width={8}
														/>
													</Form.Field>
												)}
												<Form.Input
													label="Authority Number"
													value={rx.authorityNo || ''}
													onChange={e => {
														let val = e.target.value;
														val = val.replace(/[^0-9.]/g, '');
														if (val.length > 8) {
															val = val.slice(0, 8);
														}
														rx.authorityNo = val;
													}}
													width={8}
													readOnly={isReadOnly}
													required={!isReadOnly}
												/>
												{isReadOnly ? (
													<Form.Field width={8}>
														<label>Script Date</label>
														<Form.Input value={rx.rxDate?.toDate().format() || ''} readOnly />
													</Form.Field>
												) : (
													<Form.Field width={8} required>
														<label>Script Date</label>
														<DayPickerInput
															asFormField={false}
															value={rx.rxDate?.toDate() || ''}
															onDayChange={day => {
																this.rx.rxDate = day?.toISOString();
															}}
															dayPickerProps={{
																disabledDays: { after: new Date() }
															}}
														/>
													</Form.Field>
												)}
												{isReadOnly ? (
													<Form.Input
														label="Indication"
														value={rx.ItemInfo?.indication || ''}
														width={8}
														readOnly
													/>
												) : (
													<Form.Field width={8} required>
														<label>Indication</label>
														<Dropdown
															selection
															search={true}
															autoComplete="nope"
															value={indicationValue || ''}
															options={indications}
															onChange={(e, data) => {
																this.indicationValue = data.value;
																this.onChangeReset('indication');
																this.getDrugs();
																this.fetchItemInfoDesc();
															}}
															width={8}
														/>
													</Form.Field>
												)}
												{isReadOnly ? (
													<Form.Input
														label="Drug"
														value={rx.ItemInfo?.itemName || ''}
														width={8}
														readOnly
													/>
												) : (
													<Form.Field width={8} required>
														<label>Drug</label>
														<Dropdown
															selection
															search={true}
															value={drugValue || ''}
															options={drugs}
															onChange={(e, data) => {
																this.drugValue = data.value;
																this.onChangeReset('drugName');
																this.getTreatmentPhases();
															}}
															width={8}
														/>
													</Form.Field>
												)}
												{isReadOnly ? (
													<Form.Input
														label="Treatment Phase"
														value={this.rx.treatmentType || ''}
														width={16}
														readOnly
													/>
												) : (
													<Form.Field width={16} required>
														<label>Treatment Phase</label>
														<Dropdown
															selection
															search={true}
															value={this.rx.treatmentType || ''}
															options={treatmentTypes}
															onChange={async (e, data) => {
																this.rx.treatmentType = data.value;
																await this.setValueROFields();
															}}
															width={8}
														/>
													</Form.Field>
												)}
												<Form.Input
													readOnly
													label="Status"
													value={rx.status?.toUpperCase()}
													width={8}
												/>
												<Form.Field width={8}>
													<label>Uploaded to SAM</label>
													<Form.Input
														value={rx.created?.toDate().format() || new Date().format()}
														readOnly
													/>
												</Form.Field>

												{rx.status !== 'approved' && (
													<Fragment>
														{itemInforEdit ? (
															<Form.Field width={8} required>
																<label>Item Code</label>
																<Dropdown
																	selection
																	search={true}
																	value={itemInforValue?.itemCode || ''}
																	options={itemInforEditValues}
																	onChange={async (e, data) => {
																		await this.setValueROFields(data.value);
																	}}
																	width={8}
																/>
															</Form.Field>
														) : (
															<Form.Input
																readOnly
																label="Item Code"
																value={itemInforValue?.itemCode || ''}
																width={8}
																required={!isReadOnly}
															/>
														)}
														<Form.Input
															required={!isReadOnly}
															readOnly
															label="Restriction Code"
															value={itemInforValue?.restrictionCode || ''}
															width={8}
														/>
													</Fragment>
												)}

												{['new', 'rejected', 'deferred'].includes(rx.status) && (
													<Form.Field
														required={!isReadOnly}
														control={TextArea}
														readOnly
														label="Restriction Code Description"
														value={itemInforValue?.restrictionText || ''}
														width={16}
														rows={8}
														style={{ backgroundColor: '#eeeeee' }}
													/>
												)}
												{this.therapeuticAreaValue === 1 &&
													(isReadOnly ? (
														<Fragment>
															<Form.Input label="Eye" value={rx.eye || ''} width={8} readOnly />
															<div className="eight wide field"> </div>
														</Fragment>
													) : (
														<Fragment>
															<Form.Field width={8} required>
																<label>Eye</label>
																<Dropdown
																	width={8}
																	options={eyes}
																	value={rx.eye}
																	onChange={(e, data) => {
																		this.rx.eye = data.value;
																		this.setQuantityValue();
																	}}
																	selection
																/>
															</Form.Field>
															<div className="eight wide field"> </div>
														</Fragment>
													))}
												{isReadOnly ||
												this.therapeuticAreaValue === 1 ||
												quantities.length === 1 ? (
													<Form.Input
														label="Quantity"
														value={rx.quantity || ''}
														width={8}
														readOnly
													/>
												) : (
													<Form.Field width={8} required>
														<label>Quantity</label>
														<Dropdown
															width={8}
															options={quantities}
															onChange={(e, data) => {
																this.rx.quantity = data.value;
															}}
															value={rx.quantity}
															selection
														/>
													</Form.Field>
												)}

												{isReadOnly || numberRepeats.length === 1 ? (
													<Form.Input
														label="Number of Repeats"
														value={!isNaN(rx.noOfRepeats) ? rx.noOfRepeats : ''}
														width={8}
														readOnly
													/>
												) : (
													<Form.Field width={8} required>
														<label>Number of Repeats</label>
														<Dropdown
															width={8}
															options={numberRepeats}
															onChange={(e, data) => {
																this.rx.noOfRepeats = data.value;
															}}
															value={rx.noOfRepeats}
															selection
														/>
													</Form.Field>
												)}

												{isReadOnly ? (
													<Form.Input label="Dose" value={rx.dose || ''} width={16} readOnly />
												) : (
													<Form.Field width={16} required>
														<label>Dose</label>
														<Dropdown
															width={16}
															options={doses}
															onChange={(e, data) => {
																this.doseDdlValue = data.value;
															}}
															value={this.doseDdlValue}
															selection
														/>
													</Form.Field>
												)}

												{rx && this.doseDdlValue === '-' ? (
													<Form.Input
														label="Per day"
														value={this.perDayValue || ''}
														onChange={e => {
															this.perDayValue = e.target.value?.trim();
														}}
														width={8}
														readOnly={isReadOnly}
														required={!isReadOnly}
													/>
												) : (
													<div className="eight wide field"> </div>
												)}
												{rx.status === 'rejected' && (
													<Fragment>
														<Form.Input
															readOnly
															label="Rejection Date"
															value={rx.finalisationDate?.toDate().format() || ''}
															width={8}
														/>
														<Form.Input
															readOnly
															label="Rejection Code"
															value={rx.reasonCode?.trim().replace(/\,$/, '') || ''}
															width={8}
														/>
														<Form.Field
															control={TextareaAutosize}
															readOnly={true}
															label="Rejection Reason"
															value={rx.reasonText || ''}
															width={16}
															rows={1}
															style={{ backgroundColor: '#eeeeee' }}
														/>
													</Fragment>
												)}
												<Form.Field
													control={TextArea}
													readOnly={isReadOnly && !editNotesMode}
													label="Notes"
													value={rx.notes || ''}
													onChange={e => {
														rx.notes = e.target.value;
													}}
													width={16}
													style={{
														backgroundColor: isReadOnly && !editNotesMode ? '#eeeeee' : 'initial'
													}}
												/>
												{showEditNotes && editNotesMode && (
													<div className={styles.toggleMargin}>
														<Checkbox
															label="Actioned"
															checked={rx.actioned || false}
															onChange={() => (rx.actioned = !rx.actioned)}
															toggle
														/>
													</div>
												)}
												{manualUploadSwitch && !isReadOnly && (
													<div className="sixteen wide field">
														<div className={styles.toggleMargin}>
															<Checkbox
																label="Manual upload via HPOS"
																checked={rx.manual || false}
																onChange={() => (this.rx.manual = !this.rx.manual)}
																toggle
															/>
														</div>
													</div>
												)}
												{rx.manual && (
													<Form.Field
														width={16}
														style={{ marginTop: '10px', marginBottom: '20px' }}
													>
														<div>Attachment(s)</div>
														<div>
															{!stored.length && !filesToUpload.length && (
																<div className={styles.uploadInfoCont} style={{ height: '28px' }} />
															)}
															{stored.map((f, idx) => (
																<div
																	key={idx}
																	className={styles.uploadInfoCont}
																	style={{ marginLeft: '20px' }}
																>
																	<span
																		style={{ cursor: 'pointer' }}
																		onClick={() => {
																			window.open(`/api/containers/${f.fileName}`);
																		}}
																	>
																		{f.label}
																	</span>

																	<div>
																		<Button
																			icon
																			size="mini"
																			onClick={() => {
																				window.open(`/api/containers/${f.fileName}`);
																			}}
																		>
																			<Icon name="file pdf outline" />
																		</Button>
																		{!isReadOnly && (
																			<Button
																				icon
																				size="mini"
																				onClick={() => {
																					f.deleted = true;
																				}}
																			>
																				<Icon name="delete" />
																			</Button>
																		)}
																	</div>
																</div>
															))}

															{filesToUpload.length >= 1 &&
																filesToUpload.map((f, idx) => (
																	<div
																		key={idx}
																		className={styles.uploadInfoCont}
																		style={{ marginLeft: '20px', backgroundColor: '#e0e1e2' }}
																	>
																		<span className={styles.uploadLabel}>
																			{'File to upload: '}
																			{`${f.name}`}
																		</span>
																		<Button
																			icon
																			size="mini"
																			onClick={() => {
																				self.filesToUpload.splice(idx, 1);
																			}}
																		>
																			<Icon name="delete" />
																		</Button>
																	</div>
																))}
														</div>
													</Form.Field>
												)}
												{rx.manual && isManualReadOnly && (
													<Fragment>
														<Form.Input
															readOnly
															required
															label="HPOS Upload Reference4"
															value={rx.hposUploadReference || ''}
															onChange={e => {
																let val = e.target.value;
																this.rx.hposUploadReference = val;
															}}
															width={8}
														/>
														<Form.Field width={8}>
															<label>Uploaded to HPOS</label>
															<Form.Input
																value={rx.uploadedtoHPOS?.toDate()?.format() || ''}
																readOnly
															/>
														</Form.Field>
													</Fragment>
												)}
												{rx.status === 'approved' && (
													<Fragment>
														<Form.Field width={8}>
															<label>Approval Number</label>
															<Form.Input value={rx.approvalNumber || ''} readOnly />
														</Form.Field>
														<Form.Field width={8}>
															<label>Approval Date</label>
															<Form.Input
																value={rx.finalisationDate?.toDate()?.format() || ''}
																readOnly
															/>
														</Form.Field>
													</Fragment>
												)}

												{rx.status === 'approved' && rx.warning && (
													<Fragment>
														<Form.Field width={16} row={1}>
															<label style={{ color: 'red' }}>Warning</label>
															<TextareaAutosize
																readOnly={true}
																row={1}
																value={rx.warning || ''}
																style={{ backgroundColor: '#eeeeee' }}
															/>
														</Form.Field>
													</Fragment>
												)}
											</Form.Group>
											<div className={styles.buttonsRowSpaced}>
												<div className={styles.buttonCont}>
													{showEditNotes && !editNotesMode && (
														<Button
															onClick={() => {
																this.editNotesMode = true;
															}}
														>
															Edit Notes
														</Button>
													)}
													{showEditNotes && editNotesMode && (
														<Button primary onClick={() => this.saveNotes()}>
															Save Notes
														</Button>
													)}
													{!!showDelete && this.renderDelete()}
												</div>
												<div>
													{buttonsVisible && this.renderButtons(isReadOnly, isManualReadOnly)}
													<Button onClick={onClose}>Close</Button>
												</div>
											</div>
										</Fragment>
									)}
								</Form>
							</Modal.Content>
						</Fragment>
					</Modal>
					<Modal
						size="mini"
						open={this.showDeleteConfirmDlg}
						onClose={() => (this.showDeleteConfirmDlg = false)}
						className={styles.modalConfirmation}
						closeIcon={true}
					>
						<Modal.Content>
							<p>Do you wish to permanently delete the Rx record?</p>
						</Modal.Content>
						<Modal.Actions className={styles.buttonsRowSpaced}>
							<Button
								onClick={() => {
									this.showDeleteConfirmDlg = false;
								}}
							>
								Cancel
							</Button>
							<Button
								positive
								icon="checkmark"
								labelPosition="right"
								content="OK"
								onClick={() => {
									this.showDeleteConfirmDlg = false;
									this.deleteRx();
								}}
							/>
						</Modal.Actions>
					</Modal>
					<Modal
						size="mini"
						open={this.showCancelConfirmDlg}
						onClose={() => (this.showCancelConfirmDlg = false)}
						className={styles.modalConfirmation}
						closeIcon={true}
					>
						<Modal.Content>
							<p>Are you sure you want to CANCEL this Authority with Medicare?</p>
						</Modal.Content>
						<Modal.Actions className={styles.buttonsRowSpaced}>
							<Button
								onClick={() => {
									this.showCancelConfirmDlg = false;
								}}
							>
								No
							</Button>
							<Button
								positive
								icon="checkmark"
								labelPosition="right"
								content="Yes"
								onClick={() => {
									this.showCancelConfirmDlg = false;
									this.cancelAuthority();
								}}
							/>
						</Modal.Actions>
					</Modal>
					<Modal
						size="mini"
						open={this.showIHICheckDlg}
						onClose={() => (this.showIHICheckDlg = false)}
						className={styles.modalConfirmation}
						closeIcon={true}
					>
						<Modal.Content>
							<p>Would you like to check for Individual Healthcare Identifier (IHI)?</p>
						</Modal.Content>
						<Modal.Actions className={styles.buttonsRowSpaced}>
							<Button
								onClick={() => {
									this.showIHICheckDlg = false;
								}}
							>
								No
							</Button>
							<Button
								positive
								icon="checkmark"
								labelPosition="right"
								content="Yes"
								onClick={() => {
									this.showIHICheckDlg = false;
									this.execIhiCheck();
								}}
							/>
						</Modal.Actions>
					</Modal>
				</Fragment>
			)
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Script/ScriptNew.js